import { render } from "./MmContact.vue?vue&type=template&id=5198a084"
import script from "./MmContact.vue?vue&type=script&lang=js"
export * from "./MmContact.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__